import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import _ from 'lodash'

class Autocomplete extends Component {
    static propTypes = {
        suggestions: PropTypes.instanceOf(Array)
    };

    static defaultProps = {
        suggestions: [],
        filteredSuggestions: [],
        currentIndex: 0,
        principalCode: ''
    };

    constructor(props) {
        super(props);

        this.state = {
            activeSuggestion: 0,
            filteredSuggestions: [],
            showSuggestions: false,
            userInput: []
        };
    }

    componentDidMount = () => {
        document.addEventListener('click', this.handleClickOutside())
        let app = this
        this.searchAutocomplete = _.debounce((e) => {
            app.runQuery(e)
        }, 500)
    }

    handleClickOutside = () => {
        this.setState({showSuggestions: false})
    }

    onChange = e => {
        e.persist();
        let inputValue = e.currentTarget.value
        let index = this.props.currentIndex
        let { userInput } = this.state
        userInput[index] = inputValue

        var currentElement = document.getElementById('search-' + index)
        currentElement.classList.add('loading')

        this.setState(userInput)
        this.searchAutocomplete(e.currentTarget.value)
    }

    runQuery = e => {
        // let inputValue = e.currentTarget.value
        let inputValue = e
        let start = this.props.startapi || 3
        let currentElement = document.getElementById('search-' + this.props.currentIndex)
        if (inputValue.length >= start) {
            let callFunction = this.props.onchange(inputValue)
            let app = this
            callFunction.then((response) => {
                currentElement.classList.remove('loading')
                app.setState({
                    activeSuggestion: 0,
                    filteredSuggestions: response,
                    showSuggestions: true
                });
            }).catch((e) => {
                currentElement.classList.remove('loading')
                console.log(e)
            })   
        } else {
            currentElement.classList.remove('loading')
            this.setState({ showSuggestions: false })
        }
    }

    onClick = (suggestion, index) => {
        let { userInput } = this.state
        userInput[index] = suggestion.text
        this.setState({
            activeSuggestion: 0,
            filteredSuggestions: [],
            showSuggestions: false
        });
    };

    onKeyDown = e => {
        const { activeSuggestion, filteredSuggestions } = this.state;
        if (e.keyCode === 13) {
            let { userInput } = this.state
            userInput[this.props.currentIndex] = filteredSuggestions[activeSuggestion].text
            this.setState({
                activeSuggestion: 0,
                showSuggestions: false,
                userInput
            });
            this.props.onselect(filteredSuggestions[activeSuggestion], this.props.currentIndex)
        } else if (e.keyCode === 38) {
            if (activeSuggestion === 0) {
                return;
            }

            this.setState({ activeSuggestion: activeSuggestion - 1 });
        }
        else if (e.keyCode === 40) {
            if (activeSuggestion - 1 === filteredSuggestions.length) {
                return;
            }

            this.setState({ activeSuggestion: activeSuggestion + 1 });
        }
    };

    onSelect = (suggestion, index) => {
        this.props.onselect(suggestion, index)
        let { userInput } = this.state
        userInput[index] = suggestion.text
        this.setState(userInput)
    }

    render() {
        const { onChange, onKeyDown, state: {
                activeSuggestion,
                filteredSuggestions,
                showSuggestions,
                userInput
            }
        } = this;

        let suggestionsListComponent;

        if (showSuggestions && userInput) {
            if (filteredSuggestions.length) {
                suggestionsListComponent = (
                    <ul className="suggestions">
                        {filteredSuggestions.map((suggestion, index) => {
                            let className;
                            if (index === activeSuggestion) {
                                className = "suggestion-active";
                            }

                            return (
                                <li className={className} key={index} onClick={() => { this.onSelect(suggestion, this.props.currentIndex); this.onClick(suggestion, index) }} >{suggestion.text}</li>
                            );
                        })}
                    </ul>
                );
            } else {
                suggestionsListComponent = (
                    <div className="no-suggestions">
                        <em>No suggestions, you're on your own!</em>
                    </div>
                );
            }
        }

        return (
            <Fragment>
                <input
                    type="text"
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    disabled={(this.props.isDisabled) ? true : false }
                    value={(this.props.currentvalue && this.props.currentvalue.length > 0) ? this.props.currentvalue : userInput[this.props.currentIndex]}
                    className="form-control"
                    id={"search-" + this.props.currentIndex}
                    placeholder="Search..."
                    autoComplete="off"
                />
                {suggestionsListComponent}
            </Fragment>
        );
    }
}

export default Autocomplete;